import { render, staticRenderFns } from "./swheader.vue?vue&type=template&id=e92b8d50&scoped=true&"
import script from "./swheader.vue?vue&type=script&lang=js&"
export * from "./swheader.vue?vue&type=script&lang=js&"
import style0 from "./swheader.vue?vue&type=style&index=0&id=e92b8d50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e92b8d50",
  null
  
)

export default component.exports